import { z } from "zod";

export const answerEvaluationSchema = z.object({
  id: z.number(),
  content: z.string(),
  evaluation_rate: z.number(),
  comment: z.string().nullable(),
});

export const answerEvaluationCreateSchema = answerEvaluationSchema.omit({
  content: true,
});

export type AnswerEvaluation = z.infer<typeof answerEvaluationSchema>;
export type AnswerEvaluationCreate = z.infer<
  typeof answerEvaluationCreateSchema
>;
